import { loadWidget } from '@sitevision/react';
import React from 'react';
import ReactDOM from 'react-dom';
import FrontPageBox from './molecules/frontpage-box';

export default function initializeFrontPage() {
    initializeLoginBox();
}

function initializeLoginBox() {
    loadWidget('.plf-login-box', loginBox => {
        const linkAccessDataForm = loginBox.dataset.linkAccessDataForm;
        ReactDOM.render(<FrontPageBox linkAccessDataForm={linkAccessDataForm} />, loginBox);
    });
}
